import ImageGallerySection from '../components/Common/PlatformHeroSection';
import ChallengesSection from '../components/Common/PlatformSection';
import InfoCarouselSection from '../components/Common/PlatformCardSection';
import OutcomesSection from '../components/Common/PlatformOutcomeSection';
import AvexaEnhancesSection from '../components/ChildCare/AvexaEnhancesSection';

const ChildCare = () => {
  const heroButtons = [
    {
      label: 'Learn More',
      className: 'btn-secondary',
      onClick: () => {
        document.getElementById('gallery-section').scrollIntoView({ behavior: 'smooth' });
      },
    },
  ];

  const galleryImages = [
    {
      src: '/assets/platformchild/hero1.svg',
      alt: 'Doctor examining child',
    },
    {
      src: '/assets/platformchild/hero2.svg',
      alt: 'Healthcare professional',
    },
    {
      src: '/assets/platformchild/hero3.svg',
      alt: 'Doctor with patient',
    },
    {
      src: '/assets/platformchild/hero4.svg',
      alt: 'Nurse with patient',
    },
  ];

  const challengeCards = [
    {
      image: '/assets/platformchild/2section-1.svg',
      title: 'Uneven Quality of Pediatric Care',
      description: 'Access to specialized pediatric services varies widely between regions, leading to inconsistent health outcomes.',
    },
    {
      image: '/assets/platformchild/2section-2.svg',
      title: 'Lack of Early Health Intelligence',
      description: 'Growth or developmental issues often go unnoticed due to limited use of predictive data and analytics.',
    },
    {
      image: '/assets/platformchild/2section-3.svg',
      title: 'Disconnected Ecosystem',
      description: 'Pediatricians, schools, and parents rarely share unified digital health information, causing care gaps.',
    },
    {
      image: '/assets/platformchild/2section-4.svg',
      title: 'Delayed Immunization & Tracking',
      description: 'Missed or untracked vaccinations remain a major challenge due to manual or paper-based systems.',
    },
    {
      image: '/assets/platformchild/2section-5.svg',
      title: 'Overburdened Providers',
      description: 'Pediatric specialists face high patient loads, reducing the time for personalized follow-ups and engagement.',
    },
    {
      image: '/assets/platformchild/2section-6.svg',
      title: 'Limited Family-Centered Support',
      description: 'Most systems focus on treatment, not on guiding families with preventive insights, nutrition, or wellness education.',
    },
  ];

  const cardsData = [
    {
      image: '/assets/platformchild/3section-1.svg',
      // icon: Card1Icon,
      heading: 'AI-Powered Growth Insights',
      subheading: 'Detect developmental or growth delays early through continuous, data-driven monitoring that supports timely interventions.'
    },
    {
      image: '/assets/platformchild/3section-2.svg',
      // icon: Card2Icon,
      heading: 'Tele-Pediatric Consultations',
      subheading: 'Offer seamless virtual checkups with verified specialists, ensuring expert care is always within reach.'
    },
    {
      image: '/assets/platformchild/3section-3.svg',
      heading: 'Unified Child Health Record',
      subheading: 'Store vaccinations, reports, and medical history in one secure, connected platform for easy access.'
    },
    {
      image: '/assets/platformchild/3section-4.svg',
      heading: 'Smart Reminders & Alerts',
      subheading: 'Get automatic updates for vaccinations, follow-ups, and wellness visits to stay on top of every milestone.'
    },
  ];

  const outcomesCards = [
    {
      title: 'For Patients',
      benefits: [
        'Personalized, proactive child health management',
        'Early alerts and continuous tracking for timely care',
        'Easy access to digital consultations and guidance',
      ],
      image1: '/assets/platformchild/4section-1.svg',
      image2: '/assets/platformchild/4section-2.svg',
    },
    {
      title: 'For Providers',
      benefits: [
        'Centralized dashboards with unified pediatric data',
        'Predictive insights for early risk detection',
        'Improved coordination, efficiency, and outcomes',
      ],
      image1: '/assets/platformchild/4section-3.svg',
      image2: '/assets/platformchild/4section-4.svg',
    },
  ];

  // const discoverCards = [
  //   {
  //     image: behavioralHealthImage,
  //     // icon: '🧠',
  //     title: '🧠Behavioral Health',
  //     subtitle: 'Integrating mental wellness into everyday healthcare.',
  //     link: '/behavioral-health',
  //   },
  //   {
  //     image: childCareImage,
  //     // icon: '👩',
  //     title: '👩Women Health Care',
  //     subtitle: ' Supporting women at every stage — from prevention to maternity.',
  //     link: '/child-care',
  //   },
  // ];

  return (
    <div>
      {/* Image Gallery Section */}
        <ImageGallerySection
          title="Supporting the Next Generation with Connected Pediatric Care"
          images={galleryImages}
        />

        {/* <div className="h-32 md:h-40 lg:h-48 bg-white"></div> */}
        <div className="h-14 md:h-18 lg:h-22 bg-white"></div>

    
      {/* Challenges Section */}
        <ChallengesSection
        title="Overcoming Barriers in"
        highlightedText="Pediatric Care"
        description="Avexa addresses key challenges in child healthcare — from data fragmentation to delayed interventions — by enabling smarter, more connected pediatric solutions."
        cards={challengeCards}
      />

        <InfoCarouselSection
        // backgroundColor="primary-bg"
        title="Smarter, Connected Care for"
        highlightedText="Every Child"
        description="Avexa integrates AI, telehealth, and unified data to make pediatric care proactive, accessible, and personalized.Avexa integrates AI, telehealth, and unified data to make pediatric care proactive, accessible, and personalized."
        cards={cardsData}
        />

    {/* Outcomes Section */}
      <OutcomesSection
        title="Empowering"
        highlightedText="Every Side"
        titleEnd="of Care"
        description="Avexa bridges the gap between data and care, creating measurable benefits for patients and healthcare organizations alike."
        cards={outcomesCards}
      />

    <AvexaEnhancesSection />

    </div>
  );
};

export default ChildCare;